import { ROARR, Roarr, type Logger } from 'roarr'
import { createLogWriter as createBrowserLogWriter } from '@roarr/browser-log-writer'
import createSerializeErrorMiddleware from '@roarr/middleware-serialize-error'

const isBrowser = typeof window !== 'undefined'

if (isBrowser) {
  ROARR.write = createBrowserLogWriter()
}

export default function log(): Logger {
  return Roarr.child(createSerializeErrorMiddleware())
}
